class ScienceQuality extends HTMLElement {
  connectedCallback() {
    this._waitForGsap();
  }

  _waitForGsap() {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      this._init();
    } else {
      requestAnimationFrame(() => this._waitForGsap());
    }
  }

  _init() {
    this.pills = [...this.querySelectorAll('[data-pill]')];
    this.viewport = this.querySelector('[data-viewport]');
    this.count = this.pills.length;
    if (this.count < 1) return;

    this.pillH = this.pills[0].offsetHeight || (window.innerWidth >= 1024 ? 93 : 68);
    this.gap = 4;

    this.pills.forEach((pill, i) => {
      const props = this._slotProps(i);
      gsap.set(pill, { ...props, xPercent: -50, yPercent: -50, x: 0 });
    });

    const steps = this.count - 1;
    const stepDur = 55 / steps;

    const isMobile = window.innerWidth < 1024;
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: isMobile ? 'top 80%' : 'top 90%',
        end: 'bottom 10%',
        scrub: 0.3
      }
    });

    tl.set({}, {}, 0);

    for (let step = 0; step < steps; step++) {
      const nextCurrent = step + 1;
      const pos = 22 + step * stepDur;

      this.pills.forEach((pill, i) => {
        const slot = i - nextCurrent;
        const target = this._slotProps(slot);
        tl.to(pill, {
          y: target.y,
          scale: target.scale,
          opacity: target.opacity,
          filter: target.filter,
          duration: stepDur,
          ease: 'power1.inOut'
        }, pos);
      });
    }

    tl.set({}, {}, 100);
  }

  _slotProps(slot) {
    const vpH = this.viewport.offsetHeight;
    const centerY = vpH / 2;
    const abs = Math.abs(slot);
    const sign = slot < 0 ? -1 : 1;

    const scales = { 0: 1, 1: 0.75, 2: 0.62 };
    const blurs = { 0: 0, 1: 4, 2: 7 };
    const opacities = { 0: 1, 1: 0.55, 2: 0.3 };

    if (abs > 2) {
      return {
        y: centerY + this._yOffset(abs, sign),
        scale: 0.7,
        opacity: 0,
        filter: 'blur(10px)'
      };
    }

    return {
      y: centerY + this._yOffset(abs, sign),
      scale: scales[abs],
      opacity: opacities[abs],
      filter: `blur(${blurs[abs]}px)`
    };
  }

  _yOffset(absSlot, sign) {
    if (absSlot === 0) return 0;
    const scales = { 0: 1, 1: 0.75, 2: 0.62, 3: 0.55, 4: 0.55 };
    let offset = 0;
    for (let i = 0; i < absSlot; i++) {
      const curH = this.pillH * (scales[i] || 0.7);
      const nextH = this.pillH * (scales[i + 1] || 0.7);
      offset += curH / 2 + this.gap + nextH / 2;
    }
    return offset * sign;
  }
}

customElements.define('science-quality', ScienceQuality);
